module.exports = __webpack_public_path__ + "fec459b4e2b25a6e650b316c82b5b4ad.png";